module.exports = __webpack_public_path__ + "img/manageModelImg4.88a7731f.png";